import { useEffect, useState } from 'react';

function mesurer(seuil: number): boolean {
  if (typeof window === 'undefined') return false;
  return window.innerWidth < seuil;
}

/**
 * Vrai tant que la fenêtre est plus étroite que le seuil, en pixels.
 *
 * Sert aux écrans qui proposent déjà deux affichages — tableau et cartes —
 * à choisir le bon par défaut. Un tableau de huit colonnes ouvert sur 375 px
 * ne montre que sa première colonne : la personne doit le faire glisser pour
 * découvrir qu'il y en a d'autres. La bascule reste à sa main, seul le point
 * de départ change.
 *
 * Le seuil par défaut, 768 px, est celui de `md` dans la charte Tailwind du
 * projet : la tablette en portrait garde le tableau, le téléphone non.
 *
 * La mesure passe par `matchMedia` quand il existe — il ne réveille le
 * composant qu'au franchissement du seuil — et retombe sur l'évènement
 * `resize` sinon, l'environnement de test n'ayant pas `matchMedia`.
 */
export function useEcranEtroit(seuil = 768): boolean {
  const [etroit, setEtroit] = useState(() => mesurer(seuil));

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') {
      const auRedimensionnement = (): void => setEtroit(mesurer(seuil));
      auRedimensionnement();
      window.addEventListener('resize', auRedimensionnement);
      return () => window.removeEventListener('resize', auRedimensionnement);
    }

    const requete = window.matchMedia(`(max-width: ${seuil - 1}px)`);
    const auChangement = (): void => setEtroit(requete.matches);
    auChangement();
    requete.addEventListener('change', auChangement);
    return () => requete.removeEventListener('change', auChangement);
  }, [seuil]);

  return etroit;
}
